import api from './api';
import NetworkError from '../utils/error/NetworkError';

import keyBy from 'lodash-es/keyBy';

export const CHANNELS_SET_AVAILABLE = 'CHANNELS_SET_AVAILABLE';
export const CHANNELS_SET_ACTIVE = 'CHANNELS_SET_ACTIVE';

const initialState = {
  activeChannel: '~',
  activeLocale: '~',
  availableChannels: undefined
};

export default function reducer(state = initialState, {type, payload}) {
  switch (type) {
    case CHANNELS_SET_AVAILABLE:
      return {
        ...state,
        availableChannels: keyBy(payload.map(({current, ...rest}) => rest), 'code'),
        activeChannel: payload.find(it => it.current).code,
        activeLocale: payload.find(it => it.current).defaultLocale.code
      };
    case CHANNELS_SET_ACTIVE:
      return {
        ...state,
        activeChannel: payload.channel,
        activeLocale: state.availableChannels[payload.channel].defaultLocale.code
      };
    default:
      return state;
  }
}

export function setAvailableChannels(channels) {
  return {type: CHANNELS_SET_AVAILABLE, payload: channels};
}

export function setActiveChannel(channel) {
  return {type: CHANNELS_SET_ACTIVE, payload: {channel}};
}

export function fetchChannels(requestedChannel = false) {
  return dispatch => dispatch(api.getAll('channels/'))
    .then(channelsResponse => {
      const channels = channelsResponse.content.items;

      dispatch(setAvailableChannels(channels));

      if (requestedChannel) {
        if (channels.some(it => it.code === requestedChannel)) {
          dispatch(setActiveChannel(requestedChannel));
        } else {
          throw new NetworkError(404, {code: 404, message: 'Channel does not exist'});
        }
      }
    });
}



// WEBPACK FOOTER //
// ./ducks/channels.js